/* eslint-disable */
/**
 * TODO
 * Refactor this module after the PHP guys finish the availability check. It's nonsense to count with exactly
 * two availability options and index them directly... Ugliness all-over-the-place.
 */

var LocationService = require('../locationservice');
var ProductData = require('../product');
var domutils = require('../domutils');

/** @constructor */
/** @param {HTMLElement} element */
function UIProductItem(element) {
    this.__element = element;
    this.__productAvailability = this.__element.querySelector(".channels-availability");
    this.__availabilities = this.__element.querySelectorAll("[data-product=availability] > li");
    this.__productData = new ProductData(this.__element.id.replace("product", ""));
}
UIProductItem.prototype = {
    // The initial default availability states to restore later
    __defaultDeliveryState: null,
    __defaultCollectableState: null,
    __defaultStateOther: [],
    /**
     * ProductItem's availability data from API:getProductAvailabilities()
     * @type {ProductAvailabilityType}
     */
    __productAvailabilityData: null,

    /** @returns {string} */
    getProductId: function() {
        return this.__productData.getIdentifier();
    },

    isCollectOrHomeDelivery : function(subject) {
        return ["homeDeliveryAvailable", "collectInStoreAvailable", "homeDeliveryUnavailable", "collectInStoreUnavailable"].indexOf(subject) != -1;
    },

    /** @param {ProductAvailabilityType} productAvailabilityType */
    /** @returns {void} */
    setAvailability: function setAvailability(productAvailabilityType) {
        this.__productAvailabilityData = productAvailabilityType;

        if (this.__productAvailabilityData.isSuccessful() || this.isOtherMethodAvailable()) {
            this.setDeliveryState();
            this.setCollectableState();
            this.setOtherMethodStates();
        }

        domutils.addClass(this.__productAvailability, 'bkg-fadeout');
        this.prependLocation();
    },

    /** @returns {void} */
    clearAvailability: function() {
        if (this.__productAvailabilityData.isSuccessful()) {
            this.__availabilities[0].innerHTML = this.__defaultDeliveryState;
            this.__availabilities[1].innerHTML = this.__defaultCollectableState;
        }

        if (this.isOtherMethodAvailable()) {
            this.clearOtherMethodStates();
        }

        domutils.removeClass(this.__productAvailability, 'bkg-fadeout');

        this.clearLocation();
    },

    isOtherMethodAvailable : function() {
        var allAvailableMethods = this.__element.querySelectorAll("[data-product=availability] > li.available");
        var otherMethodsCount = 0;

        var keys = Object.keys(allAvailableMethods);

        for(var i=0; i<keys.length; i++) {
            var key = keys[i];
            if (!allAvailableMethods[key] || key === "length" || key === "constructor") {
                continue;
            }

            var dataAvailability = allAvailableMethods[key].getAttribute("data-availability");
            if (this.isCollectOrHomeDelivery(dataAvailability) == false) {
                otherMethodsCount++;
            }
        }

        return otherMethodsCount > 0;
    },
    /**
     * Creates backup of default states of delivery methods other than homeDeliveryAvailable/Unavailable and collectInStoreAvailable/Unavailable
     * For download method also replaces the download icon with tick icon
     */
    setOtherMethodStates : function() {
        this.__defaultStateOther = [];

        var keys = Object.keys(this.__availabilities);

        for(var i=0; i<keys.length; i++) {
            var key = keys[i];

            if (!this.__availabilities[key] || key === "length" || key === "constructor") {
                continue;
            }

            var dataAvailability = this.__availabilities[key].getAttribute("data-availability");

            if (this.isCollectOrHomeDelivery(dataAvailability) == false)
            {
                this.__defaultStateOther[key] = this.__availabilities[key].innerHTML;
                if (dataAvailability &&
                        dataAvailability == "downloadAvailable") {
                    var iconDl = this.__availabilities.item(key).querySelector("i.dcg-icon-download");
                    if (iconDl) {
                        iconDl.className = 'dcg-icon-tick';
                    }
                }                
            }
        }
    },
    /**
     * Restores the default states backed-up by setOtherMethodStates
     */
    clearOtherMethodStates : function() {
        var keys = Object.keys(this.__defaultStateOther);
        for(var i=0; i<keys.length; i++) {
            var key = keys[i];
            if (!this.__defaultStateOther[key] || key === "length" || key === "constructor") {
                continue;
            }
            this.__availabilities[key].innerHTML = this.__defaultStateOther[key];
        }
    },

    /** @returns {void} */
    setDeliveryState:  function setDeliveryState() {
        if (this.__productAvailabilityData.isSuccessful()) {
            if (!this.__defaultDeliveryState) {
                this.__defaultDeliveryState = this.__availabilities[0].innerHTML;
            }

            var isDeliverable = this.__productAvailabilityData.isDeliverable() ? UIProductItem.Availability.DELIVERABLE : UIProductItem.Availability.UNDELIVERABLE;
            this.__availabilities[0].setAttribute("data-availability", isDeliverable);

            var icon = this.__productAvailabilityData.isDeliverable() ? "dcg-icon-tick" : "dcg-icon-cross";
            this.__availabilities[0].innerHTML = '<i class="' + icon + '"></i>' +
                this.__productAvailabilityData.getDeliveryLabel();
        }
    },

    /** @returns {void} */
    setCollectableState:  function setCollectableState() {
        if (this.__productAvailabilityData.isSuccessful()) {
            if (!this.__defaultCollectableState) {
                this.__defaultCollectableState = this.__availabilities[1].innerHTML;
            }

            var isCollectable = this.__productAvailabilityData.isCollectable() ? UIProductItem.Availability.COLLECTABLE : UIProductItem.Availability.UNCOLLECTABLE;
            this.__availabilities[1].setAttribute("data-availability", isCollectable);

            var icon = this.__productAvailabilityData.isCollectable() ? "dcg-icon-tick" : "dcg-icon-cross";
            var labelDelivery = this.__productAvailabilityData.getDeliveryLabel();
            var labelCollection = this.__productAvailabilityData.getCollectionLabel();
            var collectableStateText = labelDelivery == labelCollection ? ''
                : '<i class="' + icon + '"></i>' + this.__productAvailabilityData.getCollectionLabel();

            this.__availabilities[1].innerHTML = collectableStateText;
        }
    },

    prependLocation: function prependLocation() {
        var availability = (this.__productAvailabilityData.isDeliverable() || this.__productAvailabilityData.isCollectable() || this.isOtherMethodAvailable()) ? 'available' : 'unavailable';
        var locationDiv = document.createElement("DIV");

        this.clearLocation();
        
        locationDiv.className = "location " + availability;
        locationDiv.innerHTML = window.App.locale.getString("component.mcd.postcodechecker.checker.for") + " <span>" + LocationService.getLocation().location + "</span>";

        this.__productAvailability.insertBefore(locationDiv, this.__productAvailability.firstChild);
    },

    clearLocation: function clearLocation() {
        var locationDivs = this.__productAvailability.querySelectorAll(".location");
        if (locationDivs.length) {
            Array.prototype.forEach.call(locationDivs, function(locationDiv) {
                locationDiv.parentNode.removeChild(locationDiv);
            });
        }
    }
}

UIProductItem.prototype.getElement = function getElement() {
  return this.__element;
};

UIProductItem.prototype.hide = function hide() {
  this.__element.style.display = 'none';
};

UIProductItem.prototype.show = function show() {
  this.__element.style.display = 'block';
};

UIProductItem.prototype.isVisible = function visible() {
  return this.__element.style.display !== 'none';
};


UIProductItem.Availability = {
    DELIVERABLE: "homeDeliveryAvailable",
    UNDELIVERABLE: "homeDeliveryUnavailable",
    COLLECTABLE: "collectInStoreAvailable",
    UNCOLLECTABLE: "collectInStoreUnavailable"
}


module.exports = UIProductItem;
